export enum DiscountTypes {
  Fixed = "fixed",
  Percent = "percent",
}

export const discountTypeOptions = [
  { label: "%", value: DiscountTypes.Percent },
  { label: "$", value: DiscountTypes.Fixed },
];
